import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import jobsReducer from "../reducers/jobsReducer";
import loaderReducer from "../reducers/loaderReducer";
import selectedJobReducer from "./selectedJobReducer";
import darkModeReducer from "./darkModeReducer";
import menuReducer from "../reducers/menuReducer";

export default combineReducers({
  form: formReducer,
  jobs: jobsReducer,
  loader: loaderReducer,
  selectedJob: selectedJobReducer,
  darkMode: darkModeReducer,
  menu: menuReducer,
});
